import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, setDoc } from "firebase/firestore";
import { firestore } from "hooks/useFirebase";

export const getRef = (userId) => {
  return userId ? doc(firestore, `users/${userId}`) : null;
};

export const useUser = (userId) => {
  const ref = getRef(userId);
  const [user, loading, error] = useDocumentData(ref, {
    idField: "id",
  });
  
  const update = (data) => {
    if (ref) {
      return setDoc(ref, data, { merge: true });
    }
    return Promise.reject(new Error("No user reference available"));
  };
  
  return { user, loading, error, update };
};
